import React, { useContext, useEffect, useMemo } from 'react';

import { ProtocolApi } from '../../../../../../../api';
import modalBoxes from '../../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../../../common/general/Button';
import ButtonGroup from '../../../../../../../common/general/ButtonGroup';
import { TableSetupContext } from '../../../../../../../contexts/TableSetupContext';
import { PageInfoHeader } from '../../../../../../PageInfoHeader/PageInfoHeader';
import { generateUrlByKey, useCurrentRoute } from '../../../../../../root/router';
import SaveItemGroupAsTemplateNameChangeModal from '../../../../Protocol/ProtocolSetup/SaveItemGroupAsTemplateNameChangeModal/SaveItemGroupAsTemplateNameChangeModal';
import AddNewItemGroupMenu from '../../../AddNewItemGroupMenu/AddNewItemGroupMenu';

const ItemGroupsDetailsTableSetup = () => {
  const tableSetupContext = useContext(TableSetupContext);
  const {
    params: { studyId, protocolIdentity },
    name,
    parent
  } = useCurrentRoute();

  useEffect(() => {
    ProtocolApi.getStudyProtocolBasicInfo(studyId, protocolIdentity).then(({ data }) => {
      tableSetupContext.setProtocolName(data.response.protocolName);
      tableSetupContext.setStudyName(data.response.studyName);
      tableSetupContext.setProtocolVersion(data.response.protocolVersion);
      tableSetupContext.setTerminologyVersionGroupNumber(data.response.terminologyVersionGroupNumber);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigateBack = useMemo(() => {
    if (tableSetupContext.isTemplateMode && name !== 'Item Group Table Template Setup') {
      return generateUrlByKey('Item Group Templates');
    }
    return generateUrlByKey(
      parent.name === 'Encounter Setup' ? parent.key : 'Setup Protocol.Source Data Setup.Item Groups List',
      { studyId, protocolIdentity }
    );
  }, [name, parent.key, parent.name, protocolIdentity, studyId, tableSetupContext.isTemplateMode]);

  return (
    <PageInfoHeader
      objectRecordLabel={name === 'Item Group Table Template Setup' && tableSetupContext.studyName}
      pageInfo={
        name === 'Item Group Table Template Setup' && (
          <PageInfoHeader.CollapsibleList>
            <PageInfoHeader.AdditionalInfo tooltip="Source Data Name">
              {tableSetupContext.protocolName}
            </PageInfoHeader.AdditionalInfo>
            <PageInfoHeader.AdditionalInfo tooltip="Version">
              {tableSetupContext.protocolVersion}
            </PageInfoHeader.AdditionalInfo>
          </PageInfoHeader.CollapsibleList>
        )
      }
      right={
        <ButtonGroup>
          <Button priority="low" to={navigateBack}>
            Cancel
          </Button>
          {tableSetupContext.isTemplateMode && name !== 'Item Group Table Template Setup' ? (
            <Button priority="high" onClick={tableSetupContext.saveTable}>
              Save
            </Button>
          ) : (
            <>
              <Button priority="high" onClick={() => tableSetupContext.saveTable(true)}>
                Save
              </Button>
              <AddNewItemGroupMenu
                handleSave={tableSetupContext.saveTable}
                terminologyVersionGroupNumber={tableSetupContext.terminologyVersionGroupNumber}
              >
                <Button priority="high">Save and New</Button>
              </AddNewItemGroupMenu>
              <Button
                priority="medium"
                onClick={() => {
                  modalBoxes.open({
                    component: (
                      <SaveItemGroupAsTemplateNameChangeModal
                        elementName={tableSetupContext.itemGroupName}
                        domainCode={tableSetupContext.selectedDomain.domainCode}
                        itemGroupType={tableSetupContext.selectedType.name}
                        onSaveData={tableSetupContext.saveTable}
                      />
                    ),
                    title: 'Template Name'
                  });
                }}
              >
                Save as Template
              </Button>
            </>
          )}
        </ButtonGroup>
      }
    />
  );
};

export default ItemGroupsDetailsTableSetup;
